"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
var _PrivateAreaTablePane = _interopRequireDefault(require("./PrivateAreaTablePane.vue"));
var _PrivateAreaConfigPane = _interopRequireDefault(require("./PrivateAreaConfigPane.vue"));
var _BonusSendRecordPane = _interopRequireDefault(require("../BonusSend/BonusSendRecordPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PrivateArea',
  components: {
    PrivateAreaTablePane: _PrivateAreaTablePane.default,
    PrivateAreaConfigPane: _PrivateAreaConfigPane.default,
    BonusSendRecordPane: _BonusSendRecordPane.default
  },
  data: function data() {
    return {
      activeName: 'private_area_table',
      currentId: null,
      currentSendType: 1,
      isEdit: false,
      showConfigTab: false,
      configKey: 0,
      tabIndex: 0,
      // 发放记录Tab数组
      recordTabs: []
    };
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    },
    handleTabRemove: function handleTabRemove(targetName) {
      if (targetName === 'private_area_config') {
        this.showConfigTab = false;
        this.activeName = 'private_area_table';
        this.currentId = null;
        this.isEdit = false;
      } else {
        // 关闭记录Tab
        var recordIdx = this.recordTabs.findIndex(function (t) {
          return t.name === targetName;
        });
        if (recordIdx > -1) {
          if (this.activeName === targetName) {
            var next = this.recordTabs[recordIdx + 1] || this.recordTabs[recordIdx - 1];
            this.activeName = next ? next.name : 'private_area_table';
          }
          this.recordTabs = this.recordTabs.filter(function (t) {
            return t.name !== targetName;
          });
        }
      }
    },
    handleToPrivateAreaConfig: function handleToPrivateAreaConfig(id, sendType) {
      var _this = this;
      this.currentId = id;
      this.currentSendType = sendType;
      this.isEdit = !!id;
      this.showConfigTab = true;
      this.configKey++;
      this.$nextTick(function () {
        _this.activeName = 'private_area_config';
      });
    },
    handleToPrivateAreaRecord: function handleToPrivateAreaRecord(row) {
      var id = row.id,
        title = row.title;
      // 检查是否已存在同一个活动ID的标签页
      var existingTab = this.recordTabs.find(function (t) {
        return t.bonusSendId === id;
      });
      if (existingTab) {
        // 如果已存在，直接切换到该标签页
        this.activeName = existingTab.name;
        return;
      }
      // 否则创建新标签页
      var name = "record-".concat(++this.tabIndex);
      this.recordTabs.push({
        name: name,
        title: "\u53D1\u653E\u8BB0\u5F55 - ".concat(title),
        bonusSendId: id,
        bonusSendTitle: title
      });
      this.activeName = name;
    },
    handleSuccess: function handleSuccess() {
      this.showConfigTab = false;
      this.activeName = 'private_area_table';
      this.currentId = null;
      this.isEdit = false;
      this.$refs.private_area_table.fetchData();
    },
    handleCancel: function handleCancel() {
      this.showConfigTab = false;
      this.activeName = 'private_area_table';
    }
  }
};